const useActiveWorkspace = (): any => {
  const workspaces = localStorage.getItem('workspaces') || '[]';
  const lastActiveWorkspace = localStorage.getItem('last-active:workspace');
  const sessionWorkspace = sessionStorage.getItem('workspace') || lastActiveWorkspace;
  const workspaceArray = JSON.parse(workspaces);

  const activeWorkspace: any = workspaceArray.find((workspace: any) => workspace.workspace_id === sessionWorkspace);

  const getWorkspace = (worksapceId: string) => {
    return workspaceArray.find((workspace: any) => workspace.workspace_id === worksapceId);
  };

  const workspaceId = sessionWorkspace;

  return {
    activeWorkspace,
    lastActiveWorkspace,
    workspaces,
    workspaceId,
    getWorkspace,
    workspaceArray,
    sessionWorkspace
  };
};

export default useActiveWorkspace;
